module.exports = __webpack_public_path__ + "media/טלויזיה.6a1dbba9.mp3";